module.exports = __webpack_public_path__ + "img/unchecked1.a2413234.png";